import { render, staticRenderFns } from "./AutoSend.vue?vue&type=template&id=170b03c2&scoped=true"
import script from "./AutoSend.vue?vue&type=script&lang=js"
export * from "./AutoSend.vue?vue&type=script&lang=js"
import style0 from "./AutoSend.vue?vue&type=style&index=0&id=170b03c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b03c2",
  null
  
)

export default component.exports